import { UploadOutlined, CloseOutlined, FileOutlined, PlusOutlined, MinusCircleOutlined, MinusSquareOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import {
  Form,
  Input,
  Tabs,
  DatePicker,
  Select,
  Upload,
  InputNumber,
  Divider,
  TreeSelect,
  Switch,
  Checkbox,
  Row,
  Col,
  TimePicker,
  Tooltip,
} from 'antd';
import React, { useEffect } from 'react';
import dayjs from 'dayjs'
import { useState } from 'react';
import { HRSelect, Rating, CustomCheck, Map, Button } from 'components';
import { ColorPicker } from 'antd/es';
import ImgCrop from 'antd-img-crop';
import HRInput from 'components/Input';
import { FaMinus } from "react-icons/fa6";
import { Link } from 'react-router-dom';

const { Option } = Select;

const cyrillic = new RegExp(/([A-Za-z])/g)
const registrRegex = new RegExp(/[A-Za-z][A-Za-z][0-9]+/i)

const CustomForm = ({ fields, editData, itemLayouts, initValues, noLayoutConfig, className, ...restProps }) => {
  const [antForm] = Form.useForm();
  const [ isAddFile, setIsAddFile ] = useState(false)
  const [ isEdit, setIsEdit ] = useState(true)
  const form = restProps.form || antForm;
  const getLabel = (_field) => {
    return (
      <span
        className={`${
          _field.inputProps?.disabled ? 'text-[#888]' : ''
        }`}
      >
        {_field.label}
      </span>
    );
  };

  useEffect(() => {
    if(editData){
      reinitValues()
    }else{
      form.resetFields()
    }
  }, [editData]);

  useEffect(() => {
    if(!restProps.disabled){
      setIsEdit(restProps.disabled)
    }
    else{
      if(!isEdit){
        reinitValues()
      }
      setIsEdit(restProps.disabled)
    }
  },[restProps.disabled])

  const reinitValues = () => {
    if(editData){
      fields.map((item) => {
        if (item.type === 'date') {
          if(editData[item.name]){
            form.setFieldValue(item.name, dayjs(editData[item.name]));
          }
          else{
            form.setFieldValue(item.name, '');
          }
        }else if (item.type === 'time') {
          if(editData[item.name]){
            form.setFieldValue(item.name, dayjs(editData[item.name], 'HH:mm'));
          }
          else{
            form.setFieldValue(item.name, '');
          }
        }else if(item.type === 'component') {
          if(item.inputType === 'date'){
            item.names.map((name) => {
              form.setFieldValue(
                name,
                dayjs(editData[name])
              );
            })
          }
          else if(item.inputType === 'list'){
            form.setFieldValue(item.fieldName, editData[item.fieldName]);
          }
        }
        else if(item.type === 'select'){
          form.setFieldValue(item.name, editData[item.name] ? editData[item.name] : null);
        }
        else if(item.type === 'treeSelect'){
          form.setFieldValue(item.name, editData[item.name] ? editData[item.name] : null);
        }
        // else if(item.type === 'image'){
        //   console.log('image', item.name, editData[item.name]);
        //   form.setFieldValue(item.name, editData[item.name] ? editData[item.name] : null);
        // }
        else{
          form.setFieldValue(item.name, editData[item.name]);
        }
      });
    }
  }

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
      
    }
    return e?.fileList;
    
  };
  // console.log(normFile);

  const handleChangeEveryday = (checked, name) => {
    if(checked){
      form.setFieldValue(name, [
        'Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday',
      ])
    }
    else{
      form.setFieldValue(name, [])
    }
  }
  
  const handleChangeWeekday = (checked, name) => {
    if(checked){
      form.setFieldValue(name, [
        'Monday','Tuesday','Wednesday','Thursday','Friday'
      ])
    }else{
      form.setFieldValue(name, [])
    }
  }

  const renderFormItem = (_field, _fieldIndex) => {
    switch (_field.type) {
      case 'tabs':
        return <Tabs></Tabs>;
      case 'date':
        return (
          <Form.Item
            key={`form-item-${_field.name}-${_fieldIndex}`}
            label={getLabel(_field)}
            {..._field}
          >
            <DatePicker className='w-full' {..._field.inputProps} />
          </Form.Item>
        );
      case 'rangeDate':
        return (
          <Form.Item
            key={`form-item-${_field.name}-${_fieldIndex}`}
            {..._field}
            label={getLabel(_field)}
          >
            <DatePicker.RangePicker {..._field.inputProps} />
          </Form.Item>
        );
      case 'time':
        return (
          <Form.Item
            key={`form-item-${_field.name}-${_fieldIndex}`}
            {..._field}
            label={getLabel(_field)}
          >
            <TimePicker format={'HH:mm'} {..._field.inputProps} className='w-full' onSelect={(e) => form.setFieldValue(_field.name, e)} />
          </Form.Item>
        );
      case 'select':
        if (_field.dependentIndex) {
          return (
            <Form.Item
              noStyle
              shouldUpdate={(preValue, curValue) =>
                preValue[_field.dependentIndex] !==
                curValue[_field.dependentIndex]
              }
              className={_field.className}
              key={`form-item-${_field.name}-${_fieldIndex}`}
            >
              {({ getFieldValue, setFieldValue }) => {
                return (
                  <Form.Item
                    key={`form-item-c${_field.name}-${_fieldIndex}`}
                    {..._field}
                    label={getLabel(_field)}
                  >
                    <HRSelect
                      setFieldValue={setFieldValue}
                      getFieldValue={getFieldValue}
                      _field={_field}
                      name={_field.name}
                      optionsUrl={_field.inputProps.optionsUrl}
                      dependentValue={getFieldValue(_field.dependentIndex)}
                      placeholder={`${_field.label} сонгох`}
                      showSearch={_field.inputProps.showSearch}
                      filterOption={(input, option) =>
                        (option?.text ?? '').toLowerCase().includes(input.toLowerCase())
                      }
                      {..._field.inputProps}
                    />
                  </Form.Item>
                );
              }}
            </Form.Item>
          );
        } else {
          // if(_field.name === 'status' && !editData){
          //   form.setFieldValue('status', 0)
          // }
          return (
            <Form.Item
              key={`form-item-${_field.name}-${_fieldIndex}`}
              {..._field}
              label={getLabel(_field)}
            >
              <Select 
                allowClear
                showSearch
                filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                dropdownMatchSelectWidth={false}
                style={_field.inputProps?.style}
                className={_field.inputProps?.className}
                optionLabelProp="label"
                loading={_field?.inputProps?.loading}
                {..._field?.inputProps}
              >
                {_field.inputProps.options?.map((item, index) => (
                  <Option key={`${_field.name}-${index}`} value={item.value} label={item.label}>
                    {item.content ? item.content : item.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          );
        }
      case 'treeSelect':
        return (
          <Form.Item
            key={`form-item-${_field.name}-${_fieldIndex}`}
            {..._field}
            label={getLabel(_field)}
          >
            <TreeSelect {..._field.inputProps} />
          </Form.Item>
        );
      // case 'file':
      //   return (
      //     <>
      //       {editData && editData[_field.name] ? (
      //         <>
      //           {
      //             isAddFile ?
      //             <div className='w-full flex justify-between'>
      //               <Form.Item
      //                 valuePropName="file"
      //                 key={`form-item-c${_field.name}-${_fieldIndex}`}
      //                 {..._field}
      //                 label={getLabel(_field)}
      //                 >
      //                 <Upload maxCount={1} {..._field.inputProps}>
      //                   <Button icon={<UploadOutlined />}>Файл оруулах</Button>
      //                 </Upload>
      //               </Form.Item>
      //               <Button className='mt-7' type='primary' onClick={() =>setIsAddFile(false)}>
      //                 <CloseOutlined/>
      //               </Button>
      //             </div>
      //             :
      //             <div className='w-full flex justify-between gap-5' key={`form-item-c${_field.name}-${_fieldIndex}`}>
      //               <div>
      //                 <label className='block mb-2'>{getLabel(_field)}</label>
      //                 <Tooltip title={editData[_field.name]}>
      //                   <a
      //                   className="mt-2 flex items-start gap-2"
      //                   href={`${process.env.REACT_APP_CDN_URL}${
      //                     editData[_field.name]
      //                   }`}
      //                   target="_blank"
      //                   >
      //                     <FileOutlined size={30}/> <span className='text-xs'>{editData[_field.name]}</span>
      //                   </a>
      //                 </Tooltip>
      //               </div>
      //               <Button className='mt-7' type='primary' onClick={() => setIsAddFile(true)}>Солих</Button>
      //             </div>
      //           }
      //         </>
      //       ) : 
      //       <Form.Item
      //         valuePropName="file"
      //         key={`form-item-c${_field.name}-${_fieldIndex}`}
      //         {..._field}
      //         label={getLabel(_field)}
      //       >
      //         <Upload beforeUpload maxCount={1} {..._field.inputProps}>
      //           <Button icon={<UploadOutlined />}>Файл оруулах</Button>
      //         </Upload>
      //       </Form.Item>
      //       }
      //     </>
      //   );
      case 'file':
        return (
          <div className={`flex flex-col ${_field.className}`} key={`form-item-${_field.name}-${_fieldIndex}`}>
            <Form.Item
              beforeUpload
              key={`form-item-c${_field.name}-${_fieldIndex}`}
              name={_field.name}
              label={getLabel(_field)}
              valuePropName="file"
              getValueFromEvent={normFile}
              {..._field}
            >
              <Upload  listType='picture' accept=".pdf,.doc,.docx,.xml,.xlsx" type='drag' beforeUpload={() => false} maxCount={1} {..._field.inputProps}>
                <div className="text-grey-100">
                  <UploadOutlined className='text-[32px]'/>
                  <p>Оруулах файлаа <span className='text-primary-200'>Сонгоно</span> уу эсвэл <p>зөөж тавина уу</p></p>
                </div>
              </Upload>
            </Form.Item>
            {editData && editData[_field.name] ? (
              <a
                className="f-full"
                target='_blank'
                href={`${process.env.REACT_APP_CDN_IMG}${editData[_field.name].path}`}
              >
                <div className='flex gap-2 items-center p-4 rounded-md border'>
                  <FileOutlined className='text-primary  text-3xl' />
                  {editData[_field.name].name}
                </div>
              </a>
            ) : null}
          </div>
        );
        case 'map': 
        return (
          <Form.Item key={`form-item-${_field.name}-${_fieldIndex}`} {..._field}>
            <Map {..._field.inputProps} value={form.getFieldValue(_field.name)} onChange={form.setFieldValue} disabled={restProps.disabled}/>
          </Form.Item>
        )
      case 'files': 
        return (
          <Form.Item valuePropName="file" key={`form-item-${_field.name}-${_fieldIndex}`} {..._field}>
              <Upload beforeUpload {..._field.inputProps}>
                <Button icon={<UploadOutlined />}>Файл оруулах</Button>
              </Upload>
          </Form.Item>
        )
      case 'image':
        return (
          <div className={`flex flex-col ${_field.className}`} key={`form-item-${_field.name}-${_fieldIndex}`}>
            <Form.Item
              beforeUpload
              key={`form-item-c${_field.name}-${_fieldIndex}`}
              name={_field.name}
              label={getLabel(_field)}
              valuePropName="image"
              getValueFromEvent={normFile}
              {..._field}
            >
              {/* <ImgCrop modalTitle='Зураг засах' resetText='Дахин тохируулах' showGrid rotationSlider aspectSlider showReset> */}
                <Upload  listType='picture' accept="image/*" type='drag' beforeUpload={() => false} maxCount={1} {..._field.inputProps}>
                  <div className="text-grey-100">
                    <UploadOutlined className='text-[32px]'/>
                    <p>Оруулах зургаа <span className='text-primary-200'>Сонгоно</span> уу эсвэл <p>зөөж тавина уу</p></p>
                  </div>
                </Upload>
              {/* </ImgCrop> */}
            </Form.Item>
            {editData && editData[_field.name] ? (
              <img
                className="max-w-[100px]"
                src={`${process.env.REACT_APP_CDN_IMG}${editData[_field.name]}`}
              />
            ) : null}
          </div>
      );
      case 'textarea':
        return (
          <Form.Item
            key={`form-item-${_field.name}-${_fieldIndex}`}
            {..._field}
            label={getLabel(_field)}
          >
            <Input.TextArea
              // placeholder={`${_field.label} оруулах`}
              {..._field.inputProps}
            />
          </Form.Item>
        );
      case 'password':
        return (
          <Form.Item
            key={`form-item-${_field.name}-${_fieldIndex}`}
            {..._field}
            label={getLabel(_field)}
          >
            <Input.Password
              {..._field.inputProps}
            />
          </Form.Item>
        );
      case 'number':
        return (
          <Form.Item
            key={`form-item-${_field.name}-${_fieldIndex}`}
            {..._field}
            label={getLabel(_field)}
          >
            <InputNumber
              className='w-full'
              controls={false}
              min={0}
              {..._field.inputProps}
            />
          </Form.Item>
        );
      case 'price': 
        return(
          <Form.Item 
            key={`form-item-${_field.name}-${_fieldIndex}`}
            {..._field}
            label={getLabel(_field)}
          >
            <InputNumber
              className='w-full'
              formatter={value => `${new Intl.NumberFormat().format(value)}`}
              // placeholder={`${_field.label} оруулах`}
              {..._field.inputProps}
            />
          </Form.Item>
        )
      case 'rating':
        return (
          <Form.Item
            key={`form-item-${_field.name}-${_fieldIndex}`}
            {..._field}
            label={getLabel(_field)}
          >
            <Rating
              style='primary'
              {..._field.inputProps}
            />
          </Form.Item>
        );
      case 'cyrillic':
        return (
          <Form.Item
            key={`form-item-${_field.name}-${_fieldIndex}`}
            {..._field}
            label={getLabel(_field)}
            rules={[
              ..._field.rules,
              ({getFieldValue}) => ({
                validator(_, value) {
                  if(cyrillic.test(value)) {
                    return Promise.reject(new Error("Please use only cyrillic characters"))
                  }
                  return Promise.resolve()
                }
              })
            ]}
          >
            <Input
              {..._field.inputProps}
            />
          </Form.Item>
        );
      case 'stringNumber':
        return (
          <Form.Item
            key={`form-item-${_field.name}-${_fieldIndex}`}
            {..._field}
            label={getLabel(_field)}
            onKeyPress={(event) => {
              if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
              }
            }}
          >
            <Input
              // placeholder={`${_field.label} оруулах`}
              {..._field.inputProps}
            />
          </Form.Item>
        );
      case 'switch':
        return (
          <Form.Item
            key={`form-item-${_field.name}-${_fieldIndex}`}
            {..._field}
            label={getLabel(_field)}
            valuePropName="checked"
            >
            <Switch {..._field.inputProps} />
          </Form.Item>
        );
      case 'color':
        return (
          <Form.Item
            key={`form-item-${_field.name}-${_fieldIndex}`}
            {..._field}
            label={getLabel(_field)}
            // format='hex'
            valuePropName="value"
          >
            <ColorPicker
              showText
              presets={[
                {
                  label: 'Санал болгох',
                  colors: [
                    '#000000',
                    '#000000E0',
                    '#000000A6',
                    '#00000073',
                    '#00000040',
                    '#00000026',
                    '#0000001A',
                    '#00000012',
                    '#0000000A',
                    '#00000005',
                    '#F5222D',
                    '#FA8C16',
                    '#FADB14',
                    '#8BBB11',
                    '#52C41A',
                    '#13A8A8',
                    '#1677FF',
                    '#2F54EB',
                    '#722ED1',
                    '#EB2F96',
                    '#F5222D4D',
                    '#FA8C164D',
                    '#FADB144D',
                    '#8BBB114D',
                    '#52C41A4D',
                    '#13A8A84D',
                    '#1677FF4D',
                    '#2F54EB4D',
                    '#722ED14D',
                    '#EB2F964D',
                  ],
                },
              ]}
            />
          </Form.Item>
        );
        case 'percent':
          return (
            <Form.Item
            key={`form-item-${_field.name}-${_fieldIndex}`}
            {..._field}
            label={getLabel(_field)}
            >
            <InputNumber
              className='w-full'
              controls={false}
              formatter={(value) => `${value}%`}
              parser={(value) => value.replace('%', '')}
              // placeholder={`${_field.label} оруулах`}
              {..._field.inputProps}
              />
          </Form.Item>
        );
        case 'check':
          return (
            _field.inputProps?.indeterminatewith ? 
            <Form.Item
              key={`form-item-${_field.name}-${_fieldIndex}`}
              valuePropName="value"
              {..._field}
              label=''
            >
              <CustomCheck
                {..._field.inputProps}
                form={form}
                _field={_field}
                editData={editData}
              >
                {_field.label}
              </CustomCheck>
            </Form.Item>
            :
            <Form.Item
              key={`form-item-${_field.name}-${_fieldIndex}`}
              valuePropName="checked"
              {..._field}
              label=''
            >
              <Checkbox
                {..._field.inputProps}
                onChange={(e) => {form.setFieldValue(_field.name, e.target.checked ? 1 : 0);}}
                indeterminate={!!_field.inputProps?.indeterminatewith}
              >
                {_field.label}
              </Checkbox>
            </Form.Item>
            
        );
        case 'checkDays':
          return (
            <div {..._field} key={`form-item-${_field.name}-${_fieldIndex}`}>
              <Form.Item label='Week day' className='mb-0'>
                <Checkbox className='w-1/2 mb-2' onChange={(e) => handleChangeEveryday(e.target.checked, _field.name)}>
                  Everyday 
                </Checkbox>
                <Checkbox className='mb-2' onChange={(e) => handleChangeWeekday(e.target.checked, _field.name)}>
                  Weekday
                </Checkbox>
                <Form.Item name={_field.name} noStyle rules={_field.rules}>
                  <Checkbox.Group style={{width: '100%'}}>
                    <Row className='w-full gap-y-2'>
                      <Col span={4.8}>
                        <Checkbox value={'Monday'}>Mon</Checkbox>
                      </Col>
                      <Col span={4.8}>
                        <Checkbox value={'Tuesday'}>Tue</Checkbox>
                      </Col>
                      <Col span={4.8}>
                        <Checkbox value={'Wednesday'}>Wed</Checkbox>
                      </Col>
                      <Col span={4.8}>
                        <Checkbox value={'Thursday'}>Thu</Checkbox>
                      </Col>
                      <Col span={4.8}>
                        <Checkbox value={'Friday'}>Fri</Checkbox>
                      </Col>
                      <Col span={5}>
                        <Checkbox value={'Saturday'}>Sat</Checkbox>
                      </Col>
                      <Col span={5}>
                        <Checkbox value={'Sunday'}>Sun</Checkbox>
                      </Col>
                    </Row>
                  </Checkbox.Group>
                </Form.Item>
              </Form.Item>
            </div>
        );
      case 'component':
        return _field.component;
      case 'divider':
        return (
          <Form.Item {..._field} key={`form-item-${_field.name}-${_fieldIndex}`}>
            <Divider key={`divider-${_field.label}`} {..._field.inputProps}>
              {_field.text}
            </Divider>
          </Form.Item>
        );
      default:
        return (
          <Form.Item
            className='text'
            key={`form-item-${_field.name}-${_fieldIndex}`}
            {..._field}
            label={<span style={{ lineHeight: "16px",  minWidth: '100%' }}>{getLabel(_field)}</span>}          
          >
            <Input
              className='w-full'
              {..._field.inputProps}
            />
            {/* <HRInput
            {..._field.inputProps}
            placeholder={getLabel(_field)}
            /> */}
          </Form.Item>
        );
    }
  };

  const initialValues = () => {
    let tmp = {}
    fields.map((item) => {
      if(item.children){
        item.children.map((child) => {
          if(child.children){
            child.children.map((child) => {
              if(child.type === 'date'){
                tmp[child.name] = '';
              }
              else if(child.type === 'select'){
                if(child.inputProps?.mode === 'multiple'){
                  tmp[child.name] = [];
                }else{
                  tmp[child.name] = null;
                }
              }
              else if(child.type === 'treeSelect'){
                tmp[child.name] = null;
              }
              else if(child.type === 'switch'){
                tmp[child.name] = false;
              }
              else if(child.type === 'check'){
                tmp[child.name] = 0;
              }
            })
          }
          else{
            if(child.type === 'date'){
              tmp[child.name] = '';
            }
            else if(child.type === 'select'){
              if(child.inputProps?.mode === 'multiple'){
                tmp[child.name] = [];
              }else{
                tmp[child.name] = null;
              }
            }
            else if(child.type === 'treeSelect'){
              tmp[child.name] = null;
            }
            else if(child.type === 'switch'){
              tmp[child.name] = false;
            }
            else if(child.type === 'check'){
              tmp[child.name] = 0;
            }
          }
        })
      }
      else{
        if(item.type === 'date'){
          tmp[item.name] = '';
        }
        else if(item.type === 'select'){
          if(item.inputProps?.mode === 'multiple'){
            tmp[item.name] = [];
          }else{
            tmp[item.name] = null;
          }
        }
        else if(item.type === 'treeSelect'){
          tmp[item.name] = null;
        }
        else if(item.type === 'switch'){
          tmp[item.name] = false;
        }
        else if(item.type === 'check'){
          if(item.name === 'Active'){
            tmp[item.name] = 1;
          }
          else{
            tmp[item.name] = 0;
          }
        }
        else{
          tmp[item.name] = '';
        }
      }
    })
    return tmp
  }

  return (
    <Form
      // labelCol={!noLayoutConfig && formItemLayout.labelCol}
      // wrapperCol={!noLayoutConfig && formItemLayout.wrapperCol}
      labelAlign='left'
      layout='vertical'
      className={`grid grid-cols-12 gap-4 mt-3 items-start ${className}`}
      initialValues={initValues ? initValues : initialValues()}
      {...itemLayouts}  
      labelWrap={true}
      scrollToFirstError={true}
      preserve={false}
      {...restProps}
    >
      {fields.map((item, itemIndex) => renderFormItem(item, itemIndex ))}
      {
        restProps.children
      }
    </Form>
  );
};

CustomForm.propTypes = {
  fields: PropTypes.array,
};

CustomForm.defaultProps = {
  fields: [],
};

CustomForm.List = Form.List;
CustomForm.Item = Form.Item;   
CustomForm.useForm = Form.useForm;   
export default CustomForm;
